const JobRoles = {
    President: 1,
    Representative: 2,
    Others: 3
};

export default JobRoles;